import { useParams } from "react-router-dom";

export function Lang({ content }) {
  const { lang } = useParams();
  return content[lang];
}

export function useLang(content) {
  const { lang } = useParams();
  return content[lang];
}
